export enum CategoryEntityType {
  FAQ = "FAQ",
  CANNED_RESPONSE = "CANNED_RESPONSE",
}

export interface Category {
  id: string;
  name: string;
  icon?: string;
  entityType: CategoryEntityType;
  isPriority?: boolean;
  isArchived: boolean;
  order: number;
  hotelId: string;
  createdAt: string;
  updatedAt: string;
}
